import { render, staticRenderFns } from "./TreatmentListForm.vue?vue&type=template&id=2ca179c8&scoped=true&lang=pug&"
import script from "./TreatmentListForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentListForm.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentListForm.vue?vue&type=style&index=0&id=2ca179c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca179c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VDivider,VForm,VIcon,VRow,VSkeletonLoader,VSpacer,VTextField})
